/* tslint:disable */
/* eslint-disable */
/**
 * Client
 * Placeholder description of the order & payment instruction service. Detailed description to be provided by Monavate team.
 *
 * The version of the OpenAPI document: $project.version
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const UserPermission = {
    OrdersManager: 'orders_manager',
    OrdersViewer: 'orders_viewer',
    CardManager: 'card_manager',
    CardViewer: 'card_viewer',
    PaymentManager: 'payment_manager',
    CardPaymentManager: 'card_payment_manager',
    BankPaymentManager: 'bank_payment_manager',
    PaymentViewer: 'payment_viewer',
    IbanViewer: 'iban_viewer',
    TransactionsManager: 'transactions_manager',
    UserManager: 'user_manager',
    Developer: 'developer',
    ReportingManager: 'reporting_manager',
    PricingViewer: 'pricing_viewer',
    Monavate: 'monavate',
    ViewClients: 'view_clients',
    ManageClients: 'manage_clients',
    ViewAsClient: 'view_as_client',
    ManageAsClient: 'manage_as_client',
    ViewClientUsers: 'view_client_users',
    ManageClientUsers: 'manage_client_users',
    ViewClientIbans: 'view_client_ibans',
    ManageClientIbans: 'manage_client_ibans',
    ViewClientIntegration: 'view_client_integration',
    ManageClientIntegration: 'manage_client_integration',
    ViewClientOrders: 'view_client_orders',
    ManageClientOrders: 'manage_client_orders',
    ViewClientPayments: 'view_client_payments',
    ManageClientPayments: 'manage_client_payments',
    ViewClientTransactions: 'view_client_transactions',
    ManageClientCards: 'manage_client_cards',
    ViewClientCards: 'view_client_cards',
    ViewClientReports: 'view-client-reports'
} as const;

export type UserPermission = typeof UserPermission[keyof typeof UserPermission];



